import { SET_CATEGORY } from "../constants/common";

export const setCategory = (data) => ({
  type: SET_CATEGORY,
  data,
});
